import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({
  name: 'sort',
  standalone: false,
})
export class SortPipe implements PipeTransform {
  // Used to sort an array either in ascending or descending order (ascending by default)
  public transform<T>(value: readonly T[], key?: string, order: 'asc' | 'desc' = 'asc'): T[] {
    if (key === undefined) {
      return [...value].sort();
    }

    return orderBy(value, key, order);
  }
}
